import React from 'react';
import PropTypes from 'prop-types';
import Hotspot from './Hotspot';


class HotspotCircle extends Hotspot {
    constructor(props) {
        super(props);
    }

    getPlainSVG(color) {
            return (
        <svg width="436px" height="436px" viewBox="0 0 436 436" version="1.1" >
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="template-image-hotspot-icon" transform="translate(18.000000, 18.000000)" fill={color} fill-rule="nonzero" stroke="#FFFFFF" stroke-width="30">
                    <g id="Group" transform="translate(200.000000, 200.000000) rotate(-180.000000) translate(-200.000000, -200.000000) translate(0.000000, -0.000000)">
                        <circle id="Oval" cx="200" cy="200" r="200"></circle>
                    </g>
                </g>
            </g>
        </svg>
            )
    }


}

HotspotCircle.propTypes = { primaryColor: PropTypes.string.isRequired, };
export default HotspotCircle;

